import styled from "styled-components";

export const EditorFrameWrapper = styled.div`
  flex: 1;

  .loader-container,
  iframe {
    position: relative;
    height: 100%;
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    transition: opacity 0.2s ease-in-out;
  }

  .loader-container {
    background-color: white;
    opacity: 1;
    &.loaded {
      opacity: 0;
    }
  }

  iframe {
    border: none;
    opacity: 0;
    &.loaded {
      opacity: 1;
    }
  }
`;
